/* eslint-disable react/no-array-index-key */
import { Spacer } from '@nextui-org/react';
import React from 'react';
import DragDrop from './components/DragDrop/DragDrop';
import ItemFileUpload from './components/ItemFileUpload/ItemFileUpload';
import useUploadFast from './hooks/useUploadFast';

const UploadFast = (): JSX.Element => {
  const { files, fileTypes, handleChange, setFiles, handleRemove } =
    useUploadFast();
  return (
    <div className="flex w-full flex-col">
      <div className="m-4">
        <span className="text text-sm font-medium text-foreground-800">
          Ao importar os diversos arquivos, não saia da tela até todos serem
          importados, pois o progresso poderá ser perdido
        </span>
      </div>
      <Spacer y={4} />
      <div>
        <DragDrop
          fileTypes={fileTypes}
          handleChange={handleChange}
          callback={async () => console.log('')}
        />
      </div>
      <Spacer y={2} />
      {files.map((item, index) => (
        <div className="flex w-full flex-col gap-4 py-1"
            key={index}>
          <ItemFileUpload
            file={item}
            handleRemove={() => handleRemove(item)}
          />
        </div>
      ))}
    </div>
  );
};

export default UploadFast;
